import { ImagePlus } from "lucide-react";

const dateFormatter = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function PhotoArchive({ photos, selectedId, onSelect, onImport, heading }) {
  if (!photos.length) {
    return (
      <section className="empty-archive">
        <ImagePlus size={34} strokeWidth={1} aria-hidden="true" />
        <h2>这里还没有这类照片</h2>
        <p>换一个筛选，或从手机相册导入新的记忆。</p>
        <button className="text-button" type="button" onClick={onImport}>从手机导入</button>
      </section>
    );
  }

  return (
    <main className="archive" id="archive">
      <div className="archive-heading">
        <div>
          <h1>{heading}</h1>
          <p>{photos.length} 张照片</p>
        </div>
        <div className="archive-mark" aria-hidden="true">記<br />憶</div>
      </div>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <article className={`photo-item item-${index % 7}`} key={photo.id}>
            <button
              className={`photo-frame ${selectedId === photo.id ? "selected" : ""}`}
              type="button"
              onClick={() => onSelect(photo)}
              aria-label={`查看 ${photo.title}`}
            >
              <img src={photo.thumbUrl} alt={photo.title} loading={index < 4 ? "eager" : "lazy"} />
            </button>
            <div className="photo-caption">
              <h2>{photo.title}</h2>
              <time dateTime={photo.capturedAt}>{dateFormatter.format(new Date(photo.capturedAt)).replaceAll("/", ".")}</time>
              <p>{photo.location} <span aria-hidden="true">｜</span> {photo.solarTerm} <span aria-hidden="true">｜</span> {(photo.styles || []).slice(0, 2).join(" · ")}</p>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}
